import React from 'react';

interface Props {
  fillColor?: string;
}
function PregnancyIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none">
      <path
        d="M7.50027 1.5C7.50027 1.10218 7.34223 0.720644 7.06093 0.43934C6.77962 0.158035 6.39809 0 6.00027 0C5.60244 0 5.22091 0.158035 4.93961 0.43934C4.6583 0.720644 4.50027 1.10218 4.50027 1.5C4.50027 1.89782 4.6583 2.27936 4.93961 2.56066C5.22091 2.84196 5.60244 3 6.00027 3C6.39809 3 6.77962 2.84196 7.06093 2.56066C7.34223 2.27936 7.50027 1.89782 7.50027 1.5ZM3.00027 11C3.00027 11.5531 3.44714 12 4.00027 12V15.25C4.00027 15.6656 4.33464 16 4.75027 16C5.16589 16 5.50027 15.6656 5.50027 15.25V12H6.00027H6.50027V15.25C6.50027 15.6656 6.83464 16 7.25027 16C7.66589 16 8.00027 15.6656 8.00027 15.25V12H9.50027H10.0003C10.5534 12 11.0003 11.5531 11.0003 11V10C11.0003 8.5375 9.95652 7.32188 8.57214 7.05312L8.38152 6.0375C8.16902 4.90938 7.22214 4.07812 6.09089 4.00313C6.05964 4 6.03152 3.99688 6.00027 3.99688H5.92527L5.50027 4H5.35339C4.33777 4 3.40652 4.55937 2.92839 5.45312L1.08777 8.89688C0.894018 9.2625 1.03152 9.71563 1.39714 9.9125C1.76277 10.1094 2.21589 9.96875 2.41277 9.60312L3.00027 8.50313V11ZM5.50027 5.5H5.92527C6.40652 5.5 6.81902 5.84375 6.90964 6.31563L7.10027 7.33125C7.21277 7.9375 7.68464 8.40938 8.29089 8.52812C8.98152 8.6625 9.50339 9.27188 9.50339 10V10.5H6.00339H4.50339V6.5C4.50339 5.94688 4.95027 5.5 5.50339 5.5H5.50027Z"
        fill={fillColor}
      />
    </svg>
  );
}

export default PregnancyIcon;
